(function () {
  function fetchPrograms(toolkitId) {
    const apiUrl = `/api/cap/get-programs/${toolkitId}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        // Display the result
        const resultElement = document.getElementById("modalResult");
        resultElement.innerHTML = `
          <legend class="h3 mg-b-xs"><img src="${data.toolkit_icon}" alt=""/>${data.toolkit_name}</legend>
          <p>${data.toolkit_description}</p>
        `;

        if (data.programs.length > 0) {
          const programsList = document.createElement("div");

          data.programs.forEach((program) => {
            const listItem = document.createElement("div");
            const radioLabel = document.createElement("label");
            radioLabel.htmlFor = `program-${program.id}`;
            listItem.classList.add("radio-advanced");

            const radioButton = document.createElement("input");
            radioButton.type = "radio";
            radioButton.name = "program";
            radioButton.value = program.id;
            radioButton.id = `program-${program.id}`;

            const labelHeading = document.createElement("div");
            labelHeading.textContent = program.name;
            labelHeading.classList.add("radio-advanced__label");

            const labelDesc = document.createElement("div");
            labelDesc.textContent = program.description;

            listItem.appendChild(radioButton);
            listItem.appendChild(radioLabel);
            radioLabel.appendChild(labelHeading);
            radioLabel.appendChild(labelDesc);
            programsList.appendChild(listItem);
          });

          resultElement.appendChild(programsList);
        } else {
          resultElement.innerHTML += "<p>No programs found.</p>";
        }

        // Trigger the modal
        const modalButton = document.querySelector(
          '[data-target="programModal"]'
        );
        modalButton.click();

        // Check if the cap_program input has a value
        const capProgramInput = document.getElementById("cap_program");
        if (capProgramInput && capProgramInput.value) {
          const capProgramValue = capProgramInput.value;
          const radioButtons = document.querySelectorAll(
            'input[name="program"]'
          );
          radioButtons.forEach((radio) => {
            if (radio.value === capProgramValue) {
              radio.checked = true;
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Event listener for radio button click
  const radioButtons = document.querySelectorAll(
    'input[name="original_toolkit"]'
  );

  if (radioButtons.length > 0) {
    radioButtons.forEach((radio) => {
      radio.addEventListener("click", handleRadioChange);
    });
  }

  function handleRadioChange(event) {
    const selectedToolkitId = event.target.value;
    fetchPrograms(selectedToolkitId);
  }
})();
